//@ts-check
import * as d3 from "d3";

/**
 * @module Canvas
 */

/**
 * Sets Back ground Color
 * @param {Number} color - Hex Color
 */
export function setBackgroundColor(color) {
  let scope = this;
  scope.backgroundColor = color;
  scope.updateViewer();
}

/**
 * Resets all the elements from drawing
 * @returns {Object} It returns an object for acknowledgement of this API to the consumer side.
 */
export function resetAll() {

  let scope = this;
  if (scope.canvas && scope.canvas.children.length != 0) {
    let element = d3.select(scope.canvas).selectAll('g').each(function () {
      if (d3.select(this).attr('id') == 'labelGroup') {
        d3.select(this).remove();
      }
      if (d3.select(this).attr('status') == 'locked') {
        d3.select(this).attr('status', null);
      }
    });
    d3.selectAll('g').selectAll(scope.types).each(function () {
      scope.clearStyle(this);
    })
    if (scope.isGhostColor) scope.isGhostColor = false;
  } else { console.log('Error : Drawing is not loaded in viewer.'); }
}

/**
 * Clear all the 2D Viewer including loaded drawings, added labels.
 * @returns {Object} It returns an object for acknowledgement of this API to the consumer side.
 */
export function clearAll() {
  try {
    let scope = this;
    if (scope.canvas && scope.canvas.children.length != 0) {
      d3.select(scope.canvas).selectAll(scope.types).remove();
      var returnValue = {
        'status': 'success',
        'message': 'Viewer content is removed.'
      }
      return returnValue;
    }
    else {
      var returnValue = {
        'status': 'failed',
        'message': 'ERROR : Viewer content is already removed.'
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      'status': 'failed',
      'message': err.message
    }
    return returnValue;
  }
}

/**
 * Removes the drawing from the 2D Viewer 
 * @param {any} drawing_ID Pass the drawing id from the loaded drawing in 2D Viewer
 * @returns {Object} It returns an object for acknowledgement of this API to the consumer side.
 */
export function removeDrawing(drawing_ID) {
  try {
    let scope = this;
    if (scope.canvas && scope.canvas.children.length != 0) {
      d3.select(scope.canvas).selectAll('#' + drawing_ID).remove();
      var returnValue = {
        'status': 'success',
        'message': 'Drawing is removed.'
      }
      return returnValue;
    }
    else {
      var returnValue = {
        'status': 'failed',
        'message': 'ERROR : Drawing is already removed.'
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      'status': 'failed',
      'message': err.message
    }
    return returnValue;
  }
}